<template>
  <div class="mbw-shadow rounded-5 p-4 mx-2 h-100">
    <div class="text-orange fw-bold text-uppercase my-2 ">{{ item.type }}</div>
    <h2 class="fs-4 pt-0 pb-0 text-uppercase" v-html="item.title.rendered"></h2>
    <p v-if="item.acf.subtitle">{{ item.acf.subtitle }}</p>

    <Address :item="item"/>

    <div v-if="item.acf.notes">
      <h3 class="text-transform_unset text-black">Notes</h3>
      <p>{{ item.acf.notes }}</p>
    </div>
  </div>
</template>

<script>
import Address from "@/components/listing/includes/Address.vue";
import Services from "@/components/listing/includes/Services.vue";

export default {
  name: 'ItemComponent',
  components: {
    Services,
    Address
  },

  props: {
    item: Object
  },
}
</script>
